import { observable, makeObservable } from 'mobx'
import * as R from 'ramda'

class HomeStore {
    @observable surveys = []

    @observable activeSurveys = []

    @observable developmentSurveys = []

    @observable closedSurveys = []

    @observable industries = []

    @observable industryChooseOpen = false

    @observable industryChooseType = ''

    @observable loadSpinner = false

    @observable maxbiEntries = []

    @observable selectedTab = 'active'

    @observable creatingRapid = false

    @observable selectedSurveyLicense = ''

    @observable surveyLicenceModalVisible = false

    @observable noLicenceModalVisible = false

    surveyLicenseOptions = []

    constructor(store) {
        makeObservable(this)
        this.appStore = store
    }

    initSearch = async (maxbiStatus) => {
        this.loadSpinner = true
        if (maxbiStatus.nonMaxbi) {
            await Promise.all([this.getSurveys(), this.getIndustries()])
            // create a field in the active surveys to track surveyid productid and respondentType

            const countArr = [
                { name: 'active', count: this.surveys.activeCount },
                { name: 'development', count: this.surveys.developmentCount },
                { name: 'closed', count: this.surveys.closedCount },
            ]

            const initTab = countArr.find((t) => t.count > 0)

            if (initTab) this.selectedTab = initTab.name

            this.activeSurveys = this.surveys.activeSurveys.map((survey) => {
                survey.sIdpIdrType = JSON.stringify({
                    surveyId: survey.surveyId,
                    productId: survey.productId,
                    respondentType: survey.respondentType,
                    surveyTypeName: survey.surveyTypeName,
                })

                return survey
            })

            this.developmentSurveys = this.surveys.developmentSurveys.map((survey) => {
                survey.sIdpIdrType = JSON.stringify({
                    surveyId: survey.surveyId,
                    productId: survey.productId,
                    respondentType: survey.respondentType,
                    surveyTypeName: survey.surveyType,
                })

                return survey
            })

            this.closedSurveys = this.surveys.closedSurveys.map((survey) => {
                survey.sIdpIdrType = JSON.stringify({
                    surveyId: survey.surveyId,
                    productId: survey.productId,
                    respondentType: survey.respondentType,
                    surveyTypeName: survey.surveyTypeName,
                })

                return survey
            })
        }
        if (maxbiStatus.maxbi) {
            await this.getMaxbiEntries()
        }

        // default to false when flag is added
        if (this.appStore.hasProSurveysEnabled()) {
            this.surveyLicenseOptions.push('pro')
        }

        if (this.appStore.hasRapidSurveysEnabled()) {
            this.surveyLicenseOptions.push('rapid')
        }

        if (this.surveyLicenseOptions.length === 1) {
            this.selectedSurveyLicense = this.surveyLicenseOptions[0]
        }

        this.loadSpinner = false
    }

    getSurveys = async () => {
        this.surveys = await this.appStore.http.get('/home/surveys') // Surveys
    }

    getIndustries = async () => {
        this.industries = await this.appStore.http.get('/client/industry') // industries
    }

    showNoLicenceModal = () => {
        this.noLicenceModalVisible = true
    }

    hideNoLicenceModal = () => {
        this.noLicenceModalVisible = false
    }

    showSurveyLicenceModal = () => {
        this.surveyLicenceModalVisible = true
    }

    hideSurveyLicenceModal = () => {
        this.surveyLicenceModalVisible = false
    }

    closeSurveyLicenceModal = () => {
        this.creatingRapid = false
        this.selectedSurveyLicense = ''
        this.hideSurveyLicenceModal()
    }

    selectSurveyLicense = async (type) => {
        if (type === 'rapid') {
            this.creatingRapid = true
        }
        this.selectedSurveyLicense = type

        this.hideSurveyLicenceModal()
        this.toggleIndustryChoose('survey')
    }

    handleCreateSurvey = () => {
        const licenses = {
            pro: this.appStore.hasProSurveysEnabled(),
            rapid: this.appStore.hasRapidSurveysEnabled(),
        }

        if (Object.values(licenses).every((l) => !l)) {
            this.showNoLicenceModal()
            return
        }

        if (Object.values(licenses).every((l) => !!l)) {
            this.showSurveyLicenceModal()
            return
        }

        this.creatingRapid = licenses.rapid
        this.toggleIndustryChoose('survey')
    }

    toggleIndustryChoose = (type) => {
        const { industries } = this
        this.industryChooseType = type
        const industryChooseOpen = !this.industryChooseOpen

        if (!industryChooseOpen) {
            this.creatingRapid = false
            this.selectedSurveyLicense = ''
        }

        if (industryChooseOpen) {
            if (industries.length === 1) {
                this.openCreateItem(industries[0].code)
                return
            }
        }
        this.industryChooseOpen = industryChooseOpen
    }

    openCreateItem = (industryCode) => {
        const { industryChooseType } = this
        switch (industryChooseType) {
            case 'product':
                window.location = `/event/0/${industryCode}`
                break
            case 'survey':
                window.location = `/survey/0/${industryCode}${this.creatingRapid ? '?surveytype=R' : ''}`
                break
            default:
        }
    }

    openCreateMaxbi = () => {
        window.location = '/survey/0/CE?surveytype=EM'
    }

    openCreateRapid = () => {
        this.creatingRapid = true
        this.toggleIndustryChoose('survey')
    }

    getMaxbiEntries = async () => {
        const surveys = await this.appStore.http.get('/maxbi?limit=5&active=1')
        this.maxbiEntries = R.sortWith([
            R.descend(R.prop('closeDate')),
        ])(surveys)
    }

    changeTab = (tab) => {
        this.selectedTab = tab
    }
}

export default HomeStore
